<form [formGroup]="form">
  <div class="form-group row m-b">
    <div class="col-sm-3">
      <label class="col-sm-12 pb-1">Tipo registro</label>
      <ng-select id="tipo_integracao" class="ng-select-alternative" [readonly]="permission?.readonly_budget_select" [items]="list" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="tipo_integracao">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('tipo_integracao')" [erros]="fieldErros('tipo_integracao')"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger me-2" *ngIf="!permission?.readonly_budget_select" (click)="confirmExcluir()" type="button">Excluir exercício</button>
      <button *ngIf="!permission?.readonly_budget_select" class="btn btn-primary btn" type="btn" (click)="salvar()">Salvar</button>
    </div>
  </div>
</form>

<br>
<app-historico-atualizacoes-list [listAudit]="listAudit" [loadList]="false" [key]="'budget_id'"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>